/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForEdp extends models.GovernanceConfigurationBaseForCost {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForEdp.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForEdp>): GovernanceConfigurationBaseForEdp {
        let obj = Object.assign(new GovernanceConfigurationBaseForEdp(), model);
        GovernanceConfigurationBaseForEdp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForEdp>): GovernanceConfigurationBaseForEdp {
        if (!model) return null;
        return GovernanceConfigurationBaseForEdp.newInstance(<GovernanceConfigurationBaseForEdp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForEdp) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForEdp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForEdp): boolean {
        if (models.GovernanceConfigurationBaseForCost.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForEdp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Notes for the mentioned time period Enterprise Discount Program
     */
    notes: string;

}
